import { createFileRoute, redirect } from '@tanstack/react-router';

// The Executive dashboard was folded into Home as the owner-only "Business
// overview" block. Keep this route as a redirect so old links/bookmarks land
// on the Home dashboard instead of a dead route.
export const Route = createFileRoute('/_dashboard/dashboard/executive')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/home' });
  },
});
